import React from "react";
import "./FociiApplications.css";
import edTech from "../../../assets/products/edTech.png";
import webinar from "../../../assets/products/webinar.png";
import content from "../../../assets/products/content-creation.png";
import eCommerce from "../../../assets/products/e-commerce.png";
import gaming from "../../../assets/products/gaming.png";
import development from "../../../assets/products/software.png";

const FociiApplications = () => {
  const data = [
    {
      id: 1,
      title: "EdTech",
      img: edTech,
    },
    {
      id: 2,
      title: "Virtual Webinars",
      img: webinar,
    },
    {
      id: 3,
      title: "Content Creation",
      img: content,
    },
    {
      id: 4,
      title: " E-commerce",
      img: eCommerce,
    },
    {
      id: 5,
      title: "Gaming",
      img: gaming,
    },
    {
      id: 6,
      title: "Software Development",
      img: development,
    },
  ];
  return (
    <section id="" className="neutral-black-bg d-flex justify-content-center">
      <div className="product-section-max-width">
        <div>
          <h1 className="primary-light-text">FOCII Applications</h1>
          <div className="row">
            {data.map((data) => (
              <div key={data.id} className="col-lg-4 col-md-6 application-card">
                <div>
                  <img className="w-100" src={data.img} alt="" />
                </div>
                <h6 className="secondary-light-text">{data.title}</h6>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FociiApplications;
